'use strict';

import React from 'react';

//import Addresses from '../components/AddressesComponent'

require('styles//Archives.css');

class ArchivesComponent extends React.Component {
  render() {
    return (
      <div className="archives-component">
        <h3 className="h3">Архивы программ</h3>
        <table className="datatable">
          <tbody>
      <tr><td><a href="http://old.medinfo.kz/archives.jsp?arch=BuhGos">Бухучет государственных организаций</a></td></tr>
          </tbody>
        </table>
      </div>
    );
  }
}

ArchivesComponent.displayName = 'ArchivesComponent';

// Uncomment properties you need
// ContactComponent.propTypes = {};
// ContactComponent.defaultProps = {};

export default ArchivesComponent;


// WEBPACK FOOTER //
// ./src/components/ArchivesComponent.js